import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Publisher } from "../../../services/Publisher";
import { TagType as TrafficType } from "../../../services/TagType";

import { DEFAULT_FETCH_PARAM_SIZE } from "../../../helpers/constant/misc";
import AutocompleteSelect from "../../../components/AutoCompleteSelect/AutoCompleteSelect";

import { getIvtFilters } from "../../../reducers/ivt/selector";
import { setIvtFilters } from "../../../reducers/ivt/action";
import SimpleDateRangePicker from "../../../components/SimpleDateRangePicker/SimpleDateRangePicker";

const FilterBox = () => {
  const dispatch = useDispatch();
  const stableDispatch = useCallback(dispatch, [dispatch]);
  const filters = useSelector(getIvtFilters);
  const [publishers, setPublishers] = useState([]);
  const [trafficTypes, setTrafficTypes] = useState([]);
  const [publisher, setPublisher] = useState(filters.publisher);
  const [trafficType, setTrafficType] = useState(filters.trafficType);
  const [fromDate, setFromDate] = useState(filters.fromDate);
  const [toDate, setToDate] = useState(filters.toDate);

  const fetchPublishers = () => {
    Publisher.fetchPublishers({
      order_by: "id",
      order_direction: "ASC",
      size: DEFAULT_FETCH_PARAM_SIZE
    })
      .then((response) => {
        if (response.success) {
          const data = response.data.publishers;
          const publishers = [];
          for (let p of data) {
            publishers.push({ label: p.name, value: p.id });
          }
          setPublishers(publishers);
        } else {
          throw new Error(JSON.stringify(response.error));
        }
      })
      .catch((error) => {
        console.trace(error.message);
      });
  };

  const fetchTrafficTypes = () => {
    TrafficType.fetchTagTypes({
      order_by: "id",
      order_direction: "ASC",
      size: DEFAULT_FETCH_PARAM_SIZE
    }).then((response) => {
      if (response.success) {
        const data = response.data.tag_types;
        const trafficTypes = [];
        for (let p of data) {
          trafficTypes.push({ label: p.name, value: p.name });
        }
        setTrafficTypes(trafficTypes);
      } else {
        throw new Error(JSON.stringify(response.error));
      }
    });
  };

  const handleDateChange = (startDate, endDate) => {
    setToDate(endDate);
    setFromDate(startDate);
    if (startDate && endDate) {
      stableDispatch(
        setIvtFilters({
          ...filters,
          fromDate: startDate,
          toDate: endDate
        })
      );
    }
  };

  useEffect(() => {
    fetchPublishers();
    fetchTrafficTypes();
  }, []);

  const handlePublisherChange = (value) => {
    setPublisher(value);
    stableDispatch(
      setIvtFilters({
        ...filters,
        publisher: value
      })
    );
  };

  const handleTrafficTypeChange = (value) => {
    setTrafficType(value);
    stableDispatch(
      setIvtFilters({
        ...filters,
        trafficType: value
      })
    );
  };

  return (
    <>
      <div className="filter-box__options">
        <div className="filter-box__options-select">
          <AutocompleteSelect
            selected={publisher}
            data={publishers}
            handleChange={(value) => handlePublisherChange(value)}
            label={"Publisher"}
            showValueInLabel={true}
            enableMultiple={false}
            withDotsForStatus={false}
            cannotSelectDisabled={false}
          />
        </div>
      </div>
      <div className="filter-box__options-select">
        <AutocompleteSelect
          selected={trafficType}
          data={trafficTypes}
          handleChange={(value) => handleTrafficTypeChange(value)}
          label={"Traffic Type"}
          showValueInLabel={false}
          enableMultiple={false}
          withDotsForStatus={false}
          cannotSelectDisabled={false}
        />
      </div>

      <SimpleDateRangePicker
        startDate={fromDate}
        endDate={toDate}
        handleDateChange={handleDateChange}
      />
    </>
  );
};

export default FilterBox;
